module.exports = __webpack_public_path__ + "static/media/awschd32_402.a0d5f2bd.ico";